import React, { useCallback, useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import { ContentStateProperty, FieldProps, OnChangeValue } from '../../../../../../@types/types'
import Datepicker from '../../../../../common/inputs/datepicker/Datepicker'

export type MoveOutDateValidationResult = {
  freeUntil?: string[]
}

const FreeUntilDate: React.FC<FieldProps<MoveOutDateValidationResult>> = ({
  insertionData,
  validationMessages,
  screenName,
  wrapperClassName = 'grid-item one-whole margin-top-l',
  onChange,
}) => {
  const { t } = useTranslation()
  const defaultMinDate = useMemo(() => new Date(), [])
  const onChange1 = useCallback(
    (name: ContentStateProperty, value: OnChangeValue) => onChange({ screen: screenName, property: name }, value),
    [onChange, screenName]
  )

  return (
    <div className={wrapperClassName}>
      <Datepicker
        id='free-until'
        propertyName='freeUntil'
        errors={validationMessages?.freeUntil ?? []}
        selectedDate={insertionData.freeUntil}
        minDate={insertionData.moveInDate ?? defaultMinDate}
        labelTranslationKey={'wizard.screen.costs.freeUntil'}
        placeholder={t('wizard.screen.costs.date', 'Date')}
        onChange={onChange1}
        defaultCancelBehaviour={true}
      />
    </div>
  )
}

export default FreeUntilDate
